const getAccountInfo = token => {
	let config = {
		method: 'get'
	}
	return fetch(
		process.env.REACT_APP_ACCOUNTS_URL + '/info?code=' + token,
		config
	)
}

export default getAccountInfo



// WEBPACK FOOTER //
// /opt/build/repo/packages/utils/getAccountInfo.js